import { PaletteMode, PaletteOptions, alpha } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { blue, grey, white } from './colors';

export const background = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['background'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const opacity = mode === 'light' ? 0.15 : 0.7;
    return {
      navigation: tokens['--semantic-bg-surface-base'],
      overlay: alpha(tokens['--semantic-bg-surface-backdrop'], opacity),
      default: tokens['--semantic-bg-surface-base'],
      paper: tokens['--semantic-bg-surface-floating'],
      tooltip: tokens['--semantic-bg-surface-floating'],
      popover: tokens['--semantic-bg-surface-floating'],
      canvas: tokens['--semantic-bg-surface-base'],
      container: tokens['--semantic-bg-surface-page-container'],
      hover: tokens['--semantic-bg-interactive-neutral-hover'],
      selected: tokens['--semantic-bg-interactive-neutral-active'],
    };
  }

  return mode === 'light'
    ? {
        navigation: grey[850],
        overlay: alpha(grey[950], 0.7),
        default: white,
        paper: grey[50],
        tooltip: grey[900],
        popover: white,
        canvas: grey[50],
        container: white,
        hover: grey[50],
        selected: blue[50],
      }
    : {
        navigation: grey[850],
        overlay: alpha(grey[850], 0.7),
        default: grey[900],
        paper: grey[850],
        tooltip: grey[850],
        popover: grey[850],
        canvas: grey[950],
        container: grey[900],
        hover: grey[800],
        selected: blue[850],
      };
};
